
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A partner-provided unique ID for the consent component.`}</p>
    <p>{`This can be used to correlate the consent component back to its corresponding representation in your software.
This must be unique across all components in the questionnaire.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;